import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        asManagers: false
      },
      options: {
        asManagers: []
      },
      selected: {
        asManager: ''
      },
      editable: {
        asManager: ''
      }
    }
  },

  methods: {

    async getASManagers (context, search = '', team = '', area = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.asManager
      const fetching = context.fetching?.asManagers
      const options = context.options?.asManagers

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.asManagers = true
      context.selected.asManager = ''

      const filters = {
        filter_text: search,
        team_id: team,
        area_id: area
      }

      return await SSharedList.getASManagers(filters).then(
        ({ data }) => {
          context.options.asManagers = data.map(
            asManager => Object.assign(asManager, {
              area_manager_name: `${asManager.first_name} ${asManager.last_name}`
            })
          )
        }
      ).catch(() => {
        context.options.asManagers = []
      }).finally(() => {
        context.fetching.asManagers = false
      })
    },

    async searchASManagers (search, loading) {
      this.searchASManagersProvider(this, search, loading)
    },

    searchASManagersProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.asManagers, {
          keys: ['area_manager_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            team_id: selected.team?.id || '',
            area_id: selected.area?.id || ''
          }

          SSharedList.getASManagers(filters).then(
            ({ data }) => {
              options.asManagers = data.map(
                asManager => Object.assign(asManager, {
                  area_manager_name: `${asManager.first_name} ${asManager.last_name}`
                })
              )
            }
          ).catch(() => {
            options.asManagers = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
